import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    dashboardConfigData: {},
    dashboardWeeklyContestData: {},
    dashboardDailyContestData: {},
    dashboardMonthlyStatsData: {},
    leaderBoardTableDatas: {},
    leaderBoardHistorydata: {},
    dashboardMonthlyChartName: {},
    dashboardMonthlyParticularChartData: {},
    ContestId: '',
    dashboardLastUpdatedData: {},
    leaderboardLastUpdatedData: {},
};

const dashboardConfigSlice = createSlice({
    name: "dashboardConfigSlice",
    initialState,
    reducers: {
        saveDashboardConfig: (state, action) => {
            return { ...state, dashboardConfigData: action.payload }
        },
        saveContestId: () => {
            return { ...state, ContestId: action.payload }
        },
        saveDashboardWeeklyData: (state, action) => {
            return { ...state, dashboardWeeklyContestData: action.payload }
        },
        saveDashboardDailyData: (state, action) => {
            return { ...state, dashboardDailyContestData: action.payload }
        },
        saveDashboardMonthlyStatsData: (state, action) => {
            return { ...state, dashboardMonthlyStatsData: action.payload }
        },
        saveLeaderBoardTableData: (state, action) => {
            return { ...state, leaderBoardTableDatas: action.payload }
        },
        saveLeaderBoardHistoryData: (state, action) => {
            console.log('actionactionaction', action);
            return { ...state, leaderBoardHistorydata: action.payload }
        },
        saveMonthlyChartName: (state, action) => {
            return { ...state, dashboardMonthlyChartName: action.payload }
        },
        saveMonthlyParticularChartData: (state, action) => {
            return { ...state, dashboardMonthlyParticularChartData: action.payload }
        },
        saveGetDashboardLastupdate: (state, action) => {
            return { ...state, dashboardLastUpdatedData: action.payload }
        },
        saveGetLeaderboardLastupdate: (state, action) => {
            return { ...state, leaderboardLastUpdatedData: action.payload }
        }
    },
});

export const { saveDashboardConfig, saveGetLeaderboardLastupdate, saveGetDashboardLastupdate, saveContestId, saveMonthlyParticularChartData, saveMonthlyChartName, saveDashboardWeeklyData, saveDashboardDailyData, saveDashboardMonthlyStatsData, saveLeaderBoardTableData, saveLeaderBoardHistoryData } = dashboardConfigSlice.actions;
export default dashboardConfigSlice.reducer;
